import { SxProps, Typography } from '@mui/material'
import React, { ReactNode } from 'react'

interface Props {
    children: ReactNode
    sx?: SxProps
}

export const SubtitleHeader = ({ children, sx }: Props) => {
    return (
        <Typography
            sx={{
                fontSize: '17px',
                fontWeight: 600,
                color: 'text.primary',
                mb: '12px',
                ...sx,
            }}
        >
            {children}
        </Typography>
    )
}
